import React from 'react';
import { Box, Text, Separator, SeparatorType } from '@bechtel/gds';
import { t } from '@lingui/macro';

const RodInfoField = ({ label, value, valueColor }) => {
  return (
    <Box>
      <Text size="400" weight="600" color={valueColor}>
        {value}
      </Text>
      &nbsp;
      <Text size="400">{label}</Text>
    </Box>
  );
};

export const RodInfo = () => {
  return (
    <Box px={{ sm: '450' }} py={{ sm: '500' }} flexDirection={{ sm: 'column' }}>
      <Text size="400" weight="600">
        Rod Room - 001
      </Text>
      <Box mt={{ sm: '400' }} flexWrap={{ sm: 'wrap' }}>
        <Text size="400" style={{ opacity: '0.5' }}>
          Northwest to Column B7, OSBL
        </Text>
      </Box>
      <Separator borderWidth="1px" spacing="500" color="grey.300" type={SeparatorType.HORIZONTAL} />
      <Box justifyContent={{ sm: 'space-around' }}>
        <RodInfoField label={t`Today`} value="47" valueColor="grey.1000" />
        <RodInfoField label={t`Tomorrow`} value="64" valueColor="grey.1000" />
        <RodInfoField label={t`Priority`} value="4" valueColor="red.500" />
      </Box>
    </Box>
  );
};
